export const languageValues = {
  inputs: {
    descricao: {
      label: 'Descrição',
      placeholder: 'Digite a descrição...',
    },
  },
  pages: {
    reorderAgenda: {
      title: 'Reordenar pautas',
      breadcrumbs: {
        initial: 'Início',
        reorderAgenda: 'Reordenar pautas',
      },
      default: 'Padrão',
      advice: 'Conselho',
      coordinator: 'Coordenador',
      block: 'Bloqueada',
      closed: 'Encerrada',
      reorderingOfAgendas: 'Reordenamento de pautas',
      table: {
        heading: {
          order: 'Ordem',
          typeAgenda: 'Tipo de pauta',
          detail: 'Detalhes',
          agency: 'Agência',
          nucleou: 'Núcleo',
          agenda: 'Pauta',
          situation: 'Situação',
        },
      },
    },
    presents: {
      title: 'Presentes',
      yes: 'Sim',
      no: 'Não',
      breadcrumbs: {
        initial: 'Início',
        reorderAgenda: 'Presentes',
      },
      buttons: {
        confirmPresence: 'Confirmar presença',
        refreshPeoples: 'Atualizar participantes',
        search: 'Buscar',
      },
      cards: {
        quorumReached: 'Quórum atingido',
        onlineParticipants: 'Participantes online',
        associates: 'Associados',
        eligibleAssociates: 'Associados aptos',
        presentPeople: 'Pessoas presentes',
        guest: 'Convidados',
      },
      inputs: {
        agencyLabel: 'Agência',
        agencyPlaceholder: 'Selecione a agência',
        nucleouLabel: 'Núcleo',
        nucleouPlaceholder: 'Selecione o núcleo',
        nameOrCpfLabel: 'Nome ou CPF',
        nameOrCpfPlaceholder: 'Digite um Nome ou CPF',
      },
    },
    inPersonVoting: {
      title: 'Votação presencial em agência',
      subTitle: 'Digite seu CPF e consulte as pautas disponíveis para votação.',
      components: {
        inputCPFLabel: 'CPF',
        inputCPFPlaceholder: 'Digite seu CPF',
        confirmLabel: 'Confirmar',
      },
      error: {
        empty: 'Campo obrigatório',
        invalid: 'CPF inválido',
        noRepeat: 'CPF já realizou votação',
      },
      congratulations: 'Parabéns, sua votação foi concluída!',
      allVotes: 'Todas as pautas foram confirmadas.',
      collaboratorPerson:
        'Conforme dispõe a legislação, o associado que possuía ou possuir relação empregatícia com a cooperativa pode participar da assembleia, mas perde o direito de votar e ser votado, até que sejam aprovadas as contas do exercício em que ele deixou o emprego.',
      effectuationOfVote: {
        title: 'Efetivação da votação presencial na agência',
        subTitle: (rep: string) => {
          return `Olá ${rep}, você está representando as contas a seguir listadas. Escolha a sua opção de voto e confirme.`;
        },
        account: 'Conta',
        name: 'Nome do associado',
        presence: 'Presença',
      },
    },
  },
  components: {},
  modals: {
    eventTestAlert: {
      title: 'Aviso!',
      description: (onlyConfirm: boolean) => {
        return `Assembleias de teste não são oficiais, elas servem apenas para praticar a criação do evento.${
          !onlyConfirm ? ' Você deseja criar um evento teste?' : ''
        }`;
      },
    },
    associadoAnexoPauta: {
      videos: 'Vídeos',
      docs: 'Documentos',
      semAnexos: 'Sem anexos para exibir!',
    },
    cadastroPauta: {
      registerTitle: 'Cadastrar pauta',
      editTitle: 'Editar pauta',
      cancelSure: 'Você tem certeza que deseja cancelar?',
      cancelSutitle: 'As alterações realizadas serão desconsideradas',
      pautaAlreadyReleased:
        'Esta pauta já se encontra liberada na assembleia presencial. Caso seja editada, as alterações irão refletir no presencial também. Caso haja votos já confirmados, orientamos a revisão destes.',
      members: 'Membros',
      moreMembers: 'Indique um ou mais associados',
      voteOption: 'Opção de voto',
      addElectionCommissions: 'Comissão eleitoral',
      addAttachments: 'Adicione anexos',
      inputs: {
        pautaTypeLabel: 'Tipo de pauta',
        pautaTitleLabel: 'Titulo da pauta',
        pautaTitlePlaceholder: 'Digite o título da pauta',
        pautaDescriptionLabel: 'Descrição da pauta',
        pautaDescriptionPlaceholder: 'Digite a descrição da pauta',
        pautaOptionLabel: 'Opção de voto',
        pautaOptionPlaceholder: 'Digite a opção de voto',
        pautaAgencyLabel: 'Agência',
        pautaAgencyPlaceholder: 'Selecione o agência da pauta',
        pautaNucleousLabel: 'Núcleo',
        pautaNucleousPlaceholder: 'Selecione o núcleo da pauta',
        searchNameOrCPFLabel: 'Nome / CPF',
        searchNameOrCPFPlaceholder: 'Pesquise por nome ou CPF',
        searchMemberLabel: 'Membro',
        searchMemberPlaceholder: 'Pesquise por nome ou CPF',
        jobTitleLabel: 'Cargo',
        jobTitlePlaceholder: 'Selecione o cargo',
      },
      checkbox: {
        restrictPauta: 'Pauta restrita',
        secretPauta: 'Pauta secreta',
        proceedWithEditing: 'Desejo prosseguir com a edição',
        visibleToMember: 'Visível para o associado',
      },
      buttons: {
        addCandidates: 'Adicionar opção',
        addElectionCommissions: 'Adicionar comissão eleitoral',
        addDocuments: 'Adicionar documentos',
        addAttachments: 'Adicionar anexos',
        addVideo: 'Adicionar vídeo',
        addNew: 'Adicionar novo',
        add: 'Adicionar',
        addOption: 'Adicionar opção',
        registerPauta: 'Cadastrar pauta',
        cancel: 'Cancelar',
        edit: 'Editar',
        save: 'Salvar',
      },
      toast: {
        succesEditPauta: 'Pauta editada com sucesso.',
        errorEditPauta: 'Erro ao tentar editar pauta.',
        successRegisterPauta: 'Pauta cadastrada com sucesso.',
        errorRegisterPauta: 'Erro ao tentar cadastrar pauta.',
        successSaveAnexos: 'Anexos salvos com sucesso!',
        errorSaveAnexos: 'Erro ao salvar anexos!',
      },
    },
    anexoPauta: {
      title: 'Anexos',
      semAnexos: 'Sem anexos para exibir!',
      cancelSure: 'Você tem certeza que deseja cancelar?',
      cancelSubtitle: 'As alterações realizadas serão desconsideradas',
    },
    confirmedPresenceNotOnline: {
      title: 'Presença confirmada',
      subTitle: 'Olá! Seja bem-vindo(a)!',
      description:
        'Sua presença já está confirmada para este evento. Você ainda pode interagir com a sua cooperativa, assistir a assembleia e conferir os resultados do seu núcleo, através deste canal. Em caso de dúvidas, entre em contato com a sua agência de atendimento.',
      tableHead: {
        account: 'Conta',
        associateName: 'Nome do associado',
        nucleou: 'Núcleo',
        confirmedPresence: 'Presença confirmada',
        date: 'Data e hora presença',
      },
    },
    emancipedUser: {
      title: 'Participação de associados menores em assembleia',
      description1: 'Olá! Seja bem-vindo(a)!',
      description2:
        'Conforme disposto em legislação, o menor deverá ser representado na assembleia. Portanto, a sua presença e manifestação de voto, deverá ser realizada por seu(a) representante legal.',
      description3:
        'Fique conosco e acompanhe a assembleia e as pautas que serão tratadas.',
    },
  },
  buttons: {
    cancel: 'Cancelar',
    close: 'Fechar',
    save: 'Salvar',
    confirm: 'Confirmar',
    download: 'Baixar',
    yes: 'Sim',
    no: 'Não',
  },
  validations: {
    descricao: {
      required: 'Descrição é obrigatória',
    },
  },
  toasts: {
    error: {
      typeNotAllowed: 'Formato do arquivo não suportado!',
      uploadSize: 'Limite de arquivo é de 35 MB!',
      loadingAnexos: 'Erro ao carregar anexos!',
      downloadAnexo: 'Erro ao baixar o anexo!',
      reorderPauta: 'Houve um problema em reordenar as pautas',
      presencaNotFound: 'Não foram encontrados dados para este CPF.',
      keyErrors: (str: string, alternative?: string) => {
        switch (str) {
          case 'error.400':
            return 'Problema com dados da requisição.';
          case 'error.401':
            return 'Operação não autorizada.';
          case 'error.403':
            return 'Operação proibida.';
          case 'error.417':
            return 'Problema de validação.';
          case 'error.500':
            return 'Problema inesperado.';
          case 'error.methodArgumentTypeMismatch':
            return 'Parâmetro inválido.';
          case 'error.missingServletRequestParameter':
            return 'Falta um parâmetro.';
          case 'error.jsonProcessing':
            return 'JSON de entrada inválido.';
          case 'error.argumentNotValid':
            return 'Problema com dados da requisição.';
          case 'idVideo.notNull':
            return 'idVideo não pode ser nulo.';
          case 'idEvento.notNull':
            return 'Id do evento não pode ser nulo.';
          case 'codigoAgencia.notNull':
            return 'Código da agência não pode ser nulo.';
          case 'codigoNucleo.notNull':
            return 'Código do núcleo não pode ser nulo.';
          case 'pautas.notNull':
            return 'Lista de pautas não pode ser nulo.';
          case 'pautas.notEmpty':
            return 'Deve informar pelo menos uma pauta na lista.';
          case 'pautas.notFound':
            return 'Pautas não encontradas.';
          case 'pauta.notFound':
            return 'Pauta não encontrada.';
          case 'pauta.notClosed':
            return 'Pauta não está encerrada.';
          case 'pauta.resultadoJaLiberado':
            return 'Resultado da pauta está liberado.';
          case 'evento.notFound':
            return 'Evento não encontrado.';
          case 'evento.notFound.code':
            return 'EVNOTFOU01';
          case 'evento.notHibrido':
            return 'Evento não é Híbrido.';
          case 'eventoHibridoAgencia.notActive':
            return 'O evento está indisponível. Não é possível confirmar presença e/ou votar, confira o horário do evento para à agência.';
          case 'eventoAgn.error':
            return 'Evento não é dos tipos AGN ou REU.';
          case 'eventoAgos.error':
            return 'Evento não é dos tipos AGO, AGE ou AOE.';
          case 'idPauta.notNull':
            return 'idPauta não pode ser nulo.';
          case 'statusPauta.notNull':
            return 'Status não pode ser nulo.';
          case 'statusEvento.notNull':
            return 'Status não pode ser nulo.';
          case 'error.pesquisarParticipantesProcesso':
            return 'erro ao buscar cooperativas do usuário.';
          case 'resposta.notNull':
            return 'Resposta não pode ser nula.';
          case 'flgPublica.notNull':
            return 'flgPublica não pode ser nulo.';
          case 'documento.notFound':
            return 'Documento não encontrado.';
          case 'perfil.notFound':
            return 'Perfil usuário Enum não encontrado.';
          case 'idItemPauta.notNull':
            return 'idItemPauta não pode ser nulo.';
          case 'quantidadeVotos.notNull':
            return 'quantidadeVotos não pode ser nulo.';
          case 'itensPauta.notNull':
            return 'Lista de itens de pauta não pode ser nula.';
          case 'flagDeclaracaoSemVotos.notNull':
            return 'A declaração não pode ser nulo.';
          case 'flagDeclaracaoSemVotos.must.checked':
            return 'A declaração deve ser marcado quando não existem votos preenchidos.';
          case 'flagDeclaracaoSemVotos.cannot.checked':
            return 'A declaração não pode ser marcado quando existem votos preenchidos.';
          case 'codigoCooperatia.notFound':
            return 'Código da cooperativa não encontrado na configuração de núcleos';
          case 'coopEOWS.notFound':
            return 'Cooperativa não encontrada na estrutura organizacional.';
          case 'idDuvida.notNull':
            return 'idDuvida da Dúvida não pode ser nulo.';
          case 'duvida.notFound':
            return 'Duvida não encontrada.';
          case 'duvida.notNull':
            return 'Dúvida não pode ser nula.';
          case 'statusEvento.notFound':
            return 'Status de evento não encontrado.';
          case 'tipoPauta.notNull':
            return 'Tipo da Pauta não pode ser nulo.';
          case 'tituloPauta.notNull':
            return 'Título da Pauta não pode ser nulo.';
          case 'descriaoItemPauta.notNull':
            return 'Descrição do Item da Pauta não pode ser nula.';
          case 'video.notFound':
            return 'Video não encontrado.';
          case 'url.notNull':
            return 'URL não pode ser nula.';
          case 'descricao.notNull':
            return 'Descrição não pode ser nula.';
          case 'dataBloqueio.error':
            return 'Não é possível efetuar o bloqueio do evento. Atualize a tela da Assembleia.';
          case 'statusChat.notNull':
            return 'Status do chat não pode ser nulo.';
          case 'statusChat.notFound':
            return 'Status do chat não encontrado.';
          case 'quantidade.notMatch':
            return 'Quantidade de votos informada é maior que a quantidade de presenças confirmadas.';
          case 'cooperativa.notFound':
            return 'Cooperativa não encontrada.';
          case 'statusEventoNaoDisponivel.error':
            return 'Não é possível alterar a situação do evento, a situação atual não é Pré Assembleia.';
          case 'statusEventoPre.error':
            return 'Não é possível alterar a situação do evento, a situação atual não é Não Disponível ou Assembleia.';
          case 'statusEventoPre.pautaError':
            return 'Não é possível alterar a situação do evento, existem pautas não bloqueadas.';
          case 'statusEventoPre.hibrida_tablet':
            return 'Não é possível alterar a situação do evento, modo do evento é Híbrido-Tablet.';
          case 'statusEventoLive.error':
            return 'Não é possível alterar a situação do evento, a situação atual não é Não Disponível ou Pré Assembleia.';
          case 'statusEventoLive.errorBloqueio':
            return 'Não é possível alterar a situação do evento. Realize primeiramente o bloqueio do evento.';
          case 'statusEventoPos.error':
            return 'Não é possível alterar a situação do evento, situação não é válida.';
          case 'statusEventoEncerrado.errorPauta':
            return 'Não é possível alterar a situação do evento, existem pautas não encerradas.';
          case 'statusEventoEncerrado.errorPautaVotacao':
            return 'Não é possível alterar a situação do evento, existem pautas em processamento de votos.';
          case 'statusEventoEncerrado.missingVotes':
            return 'Evento possui pauta que ainda não possui voto computado para todas Agências/Núcleos.';
          case 'statusEventoEncerrado.error':
            return 'Não é possível alterar a situação do evento, a situação atual não é Assembleia.';
          case 'statusEventoEncerradoQuorum.errorTipo':
            return 'Não é possível alterar a situação do evento, o tipo do evento deve ser AGN.';
          case 'statusEventoEncerradoQuorum.errorHasQuorum':
            return 'Não é possível alterar a situação do evento, evento possui quórum para votação.';
          case 'statusEventoEncerradoQuorum.errorChat':
            return 'Não é possível habilitar o chat para eventos encerrados sem quórum.';
          case 'cooperativa.error':
            return 'Esta cooperativa já existe na lista.';
          case 'parametro.notNull':
            return 'Parâmetro não pode ser nulo.';
          case 'parametroOcultarNomeChat.notNull':
            return 'Parâmetro ocultar nome do chat não pode ser nulo.';
          case 'tipoResultado.notNull':
            return 'Parâmetro Tipo de Resultado não pode ser nulo.';
          case 'permissaoCooperativa.error':
            return 'Usuário não tem permissão para adicionar essa cooperativa.';
          case 'quantidadeVotoPesencial.error':
            return 'Votos incoerentes.';
          case 'pauta.error':
            return 'Não é possível modificar Pautas devido a situação do evento.';
          case 'pauta.missingVotes':
            return 'Pauta ainda não possui voto computado para todas Agências/Núcleos.';
          case 'pauta.missingVotes.code':
            return 'MSSNGVTS01';
          case 'pautaRestritaUpdate.error':
            return 'Não é possível alterar a opção Restrita após liberar a pauta ou bloquear o evento.';
          case 'deletePauta.error':
            return 'Não é possível excluir a Pauta pois já foi liberada para votação pelo menos uma vez.';
          case 'itemPauta.error':
            return 'É obrigatório existir um item de tipo Abstenção.';
          case 'itemAbstencao.notFound':
            return 'Não é possível inserir apenas o item de Abstenção, uma outra opção de voto deve existir.';
          case 'statusEvento.error':
            return 'Não é permitido bloquear, status do evento está diferente de Disponível.';
          case 'parametroCoopStatusEventoLive.error':
            return 'Não é possível alterar os parâmetros da cooperativa, existem eventos na situação assembleia.';
          case 'parametroCoopDelete.error':
            return 'Não é possível excluir os parâmetros da cooperativa, existem eventos na situação assembleia.';
          case 'quorum.notFound':
            return 'Não há presença marcada para este evento.';
          case 'quorum.alreadyDefined':
            return 'Quórum já foi definido.';
          case 'tipoPauta.notFound':
            return 'Tipo de pauta não encontrado.';
          case 'pautaEventoHibrido.error':
            return 'Não é possível modificar Pautas, evento de modo Híbrido já esta bloqueado.';
          case 'itemPauta.notFound':
            return 'Item de Pauta não encontrado.';
          case 'presenca.notFound':
            return 'Não há presença confirmada apta a votar nesta pauta.';
          case 'eventoStatus.invalid':
            return 'Para emitir o relatório o evento precisa estar no status Encerrado.';
          case 'eventoModoApresentacao.invalid':
            return 'Relatório só pode ser emitido para eventos Online ou Híbridos.';
          case 'texto.notNull':
            return 'Campo texto não pode ser nulo.';
          case 'urlVideo.notNull':
            return 'Campo url não pode ser nulo.';
          case 'parametroCoopStatusEventoLiveOrPre.error':
            return 'Não é possível alterar os parâmetros da cooperativa, existem eventos na situação Assembleia ou Pré assembleia.';
          case 'titulo.notNull':
            return 'Título não pode ser nulo.';
          case 'date.notNull':
            return 'Data não pode ser nula.';
          case 'dateStart.notNull':
            return 'Data inicial não pode ser nula.';
          case 'dateFinish.notNull':
            return 'Data final não pode ser nula.';
          case 'datEventoOnline.error':
            return 'Em eventos do modo Híbrido, as datas não podem ser nulas.';
          case 'statusEventoLive.errorUrlTransmissao':
            return 'Necessário cadastrar URL de transmissão.';
          case 'statusEventoEncerradoQuorum.errorTipoEvento':
            return 'Não é possível alterar a situação do evento, o tipo do evento deve ser Híbrido agência ou Online.';
          case 'statusEventoLive.errorModoHibrido':
            return 'Não é possível alterar a situação do evento, finalize o evento nos dispositivos offline.';
          case 'statusEventoLive.errorModoHibridoInconsistente':
            return 'Não é possível alterar a situação do evento, há inconsitência em votos no evento presencial';
          case 'statusEventoLive.errorModoHibridoInconsistente.code':
            return 'MDHBRDNCST01';
          case 'restrito.notVote':
            return 'Conta restrita não pode votar nessa pauta.';
          case 'err.userDuvida':
            return 'Problemas ao montar dados de duvidas.';
          case 'flgDisponivelAssociado.notNull':
            return 'Flag não pode ser nula.';
          case 'oidDocumento.notNull':
            return 'oidDocumento não pode ser nulo.';
          case 'nomeDocumento.notNull':
            return 'Nome do documento não pode ser nulo.';
          case 'arquivo.notNull':
            return 'Arquivo não pode ser nulo.';
          case 'tamanhoDoc.notNull':
            return 'Tamanho do documento não pode ser nulo.';
          case 'tipoDocumento.notNull':
            return 'Tipo de documento não pode ser nulo.';
          case 'coop.notFound':
            return 'Cooperativa não encontrado.';
          case 'modoEvento.notFound':
            return 'Modo de Evento não encontrado.';
          case 'evento.notConvocados':
            return 'Evento não disponível, verifique a situação do evento no Pertencer.';
          case 'dataInicioCadastro.notNull':
            return 'Data inicial do filtro não pode ser nula.';
          case 'dataFimCadastro.notNull':
            return 'Data final do filtro não pode ser nula.';
          case 'respostaPadrao.exceeded.limit':
            return 'Sua Cooperativa já atingiu o limite de respostas padrão.';
          case 'respostaPadrao.notFound':
            return 'Resposta padrão não encontrado.';
          case 'respostaPadrao.denied':
            return 'Não possui acesso a está resposta padrão.';
          case 'cooperative.denied':
            return 'Não possui acesso a está cooperativa.';
          case 'feature.doesnt.work.with.offline':
            return 'Esta funcionalidade não funciona com os eventos presencial.';
          case 'statusEvento.notWorking':
            return 'Funcionalidade indisponível para o status atual do evento.';
          case 'expiry.period':
            return 'Período da duração foi expirado.';
          case 'idConvocado.notNull':
            return 'Id do convocado não pode ser nulo.';
          case 'convocado.notFound':
            return 'Convocado não encontrado.';
          case 'representante.notFound':
            return 'Representante do núcleo não encontrado.';
          case 'representante.alreadyActive':
            return 'Representante do núcleo informado já pertence ao quórum informado.';
          case 'quorum.alreadyUpdated':
            return 'Representante do núcleo já foi modificado.';
          case 'eventoHibridoSimultaneo.notActive':
            return 'O evento está indisponível. Não é possível confirmar presença, confira o horário do evento.';
          case 'presence.notFound':
            return 'Não existe nenhuma presenca através da agência, núcleo e pauta informada';
          case 'presence.management.invalid':
            return 'Não tem nenhum usuário realizando a votação';
          case 'vote.flagNoVotes.invalid':
            return 'Foi marcado a flag sem votos, porém existem votos ou foi realizado a aclamação';
          case 'vote.quantityVotes.exceeded':
            return 'A quantidade de votos é maior que a quantidade de presentes aptos';
          case 'pauta.notAwareToDelete':
            return 'Não foi possível excluir, pois a pauta já foi liberada no presencial';
          case 'pauta.notAwareToEdit':
            return 'Não foi possível editar, pois a pauta já foi liberada no presencial';
          case 'pauta.presentialResultNotReleased':
            return 'Não é possível encerrar evento, resultado presencial ainda não foi liberado';
          case 'event.isntPreEvent':
            return 'Evento não disponível, para prosseguir altere o status do evento para preparação.';
          case 'cpf.presentInOtherChannel.ONLINE':
            return 'Cpf possui contas com presença confirmada pelo canal digital.';
          case 'user.conflictAction':
            return 'Ação já iniciada por outro usuário.';
          case 'access.denied.simultaneous.vote.computation':
            return 'Já existe um processo de computação de votos ativo!';
          default:
            return alternative
              ? alternative
              : 'Um problema inesperado ocorreu. Aguarde alguns minutos e tente novamente.';
        }
      },
    },
    success: {
      reorderPauta: 'As pautas foram reordenadas',
    },
  },
};
